export const printCurrency = (number: number, cents: boolean = true) => {
  return number.toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: 2,
  })
}

export const currencyComparator = (currency1: string, currency2: string) => {
  const currency1Number = parseCurrency(currency1)
  const currency2Number = parseCurrency(currency2)
  if (currency1Number === null && currency2Number === null) {
    return 0
  }
  if (currency1Number === null) {
    return -1
  }
  if (currency2Number === null) {
    return 1
  }
  return currency1Number - currency2Number
}

function parseCurrency(currency: string): number {
  return Number(
    currency
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '')
      .replace(',', '.'),
  )
}

export function limitDecimals(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals)
  return Math.round(value * factor) / factor
}
export function progressPercentage(done: number, max: number) {
  return limitDecimals((done / max) * 100, 0)
}
